var map = {
	"./Cover.vue": "oxK3",
	"./Icon.vue": "/G2m",
	"./Profile.vue": "Qr9m",
	"./Ubutton.vue": "DwWU",
	"./UbuttonList.vue": "thKJ",
	"./Ucalendar.vue": "cxNx",
	"./Ucolor.vue": "fFIE",
	"./Umenu.vue": "ecti",
	"./Uselectbox.vue": "/Yki"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nr1y";


//////////////////
// WEBPACK FOOTER
// ./src/components/ui [A-Z]\w+\.(vue|js)$
// module id = nr1y
// module chunks = 95